import { useState, useEffect, createRef, createContext } from "react";
import {Link, useLocation} from "react-router-dom";
import axios from "axios";
import parse from 'html-react-parser';
import { clear } from "console";
import Cart from "../components/Cart";
import { addEmitHelper } from "typescript";

type HeaderProps = {
    
  size: number
}


export default function Header({size}:HeaderProps) 
{
  const location = useLocation();
const [counter2, setCounter2] = useState( JSON.parse(sessionStorage.getItem("basket") || '0'));
const basket = JSON.parse(sessionStorage.getItem("basket") || '0');   

  




function clear(){
  sessionStorage.removeItem("basket");
  sessionStorage.removeItem("person");
  sessionStorage.removeItem("aga");
  setCounter2(0);
  console.log("cleared");
}

function addtobasket()
{
  sessionStorage.setItem("basket", "1")
  setCounter2(1);
  console.log("added");
}

  
    
    return (  
      
        <nav className="navbar navbar-expand-md navbar-light bg-white border-1 border-bottom border-opacity-10">
          <div className="container bg-white">
          <div className="col-12">
            <div className="row">
            <div className="col-9 col-sm-10 py-2">
              <a className="navbar-brand" href="/"><img alt="" src="../../usga_logo.png" height="35"></img>
              </a>
            </div>
            
            <div className="col-3 col-sm-2 pe-0">
              
              {location.pathname !=="/confirmation" ?
              <div className="text-end me-0 pe-0 pt-1">
                <i className="bi bi-cart3 fs-3"></i>
                <span className="badge text-bg-danger translate-middle bg-danger border border-light rounded-circle">{ JSON.parse(sessionStorage.getItem("basket") || '0')}</span>              
              </div>
              : "" }


              </div>
              </div>
              </div>
            </div>
         
        </nav>

      
      
    );

}

